"use client";

interface WaveformProps {
  peaks: number[];
  /** Playback position as a percentage (0-100), matching useAudioPlayer.progress. */
  progress?: number;
  color?: string;
  playColor?: string;
  height?: number;
  /** Reserved for compatibility — wobble animation is no longer used; progress drives the playhead instead. */
  animated?: boolean;
  dim?: boolean;
}

export function Waveform({
  peaks,
  progress = 0,
  color = "var(--tls-fg-strong)",
  playColor,
  height = 44,
  dim = false,
}: WaveformProps) {
  // progress is 0-100 (percent); convert to a fraction for the playhead split.
  const fraction = Math.max(0, Math.min(1, progress / 100));
  const playedCount = Math.floor(peaks.length * fraction);
  const headColor = playColor || color;
  const idleColor = color || "color-mix(in srgb, var(--tls-fg-strong) 22%, transparent)";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        height,
        width: "100%",
      }}
    >
      {peaks.map((p, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            height: Math.max(2, Math.min(p, height - 4)) + "px",
            background:
              i < playedCount
                ? headColor
                : dim
                  ? "var(--tls-border)"
                  : idleColor,
            borderRadius: 1,
            transition: "background-color var(--motion-duration-fast) var(--motion-ease-standard)",
          }}
        />
      ))}
    </div>
  );
}
